import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PersonalIcon from "@material-ui/icons/Person";
import SharedIcon from "@material-ui/icons/People";
import GlobalIcon from "@material-ui/icons/Public";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import AsyncComboBox from "eai-configurator-ui/components//base/AsyncComboBox";
import { useSessionInfo } from "eai-configurator-ui/components/SessionInfo";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%"
    },
    avatar: {
      backgroundColor: "rgba(0, 0, 0, 0)"
    },
    textField: {
      width: "100%"
    },
    dialogTitle: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1.5),
      top: theme.spacing(1.5),
      color: theme.palette.grey[500]
    },
    formControl: {
      width: "100%",
      minWidth: 200
    },
    menuIcon: {
      marginRight: theme.spacing(1)
    }
  };
});
var PERMISSION_PERSONAL = "Personal";
var PERMISSION_GLOBAL = "Global";
var PERMISSION_TEAM = "Team";
var PERMISSION_HELPER_TEXT = {
  Personal: "Only visible to the user who creates it",
  Global: "Visible to all users",
  Team: "Users in the same team share definitions"
};
var TeamsConfigurationPermission = function TeamsConfigurationPermission(_ref) {
  var permissions = _ref.permissions,
    setPermissions = _ref.setPermissions,
    teamsUrl = _ref.teamsUrl;
  var classes = useStyles();
  var _useState = useState(permissions ? permissions.name : PERMISSION_PERSONAL),
    _useState2 = _slicedToArray(_useState, 2),
    permissionName = _useState2[0],
    setPermissionName = _useState2[1];
  var _useState3 = useState(permissions ? permissions.value : null),
    _useState4 = _slicedToArray(_useState3, 2),
    permissionTeams = _useState4[0],
    setPermissionTeams = _useState4[1];
  var _useSessionInfo = useSessionInfo(),
    _useSessionInfo2 = _slicedToArray(_useSessionInfo, 1),
    sessionInfo = _useSessionInfo2[0];
  React.useEffect(function () {
    setPermissions({
      name: permissionName,
      value: permissionTeams
    });
  }, [permissionName, permissionTeams]);
  var handlePermissionNameChange = function handlePermissionNameChange(event) {
    var name = event.target.value;
    setPermissionName(name);
    if (name !== PERMISSION_TEAM) {
      setPermissionTeams(null);
    }
  };
  var isAdmin = sessionInfo.roles.includes("admin");
  var url = teamsUrl;
  if (!url) {
    url = "cloudapi/configuration/teams?username=" + sessionInfo.username;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "demo-simple-select-outlined-label"
  }, "Permission Level"), /*#__PURE__*/React.createElement(Select, {
    labelId: "permission-label",
    id: "permission-select",
    label: "Permission Layer",
    value: permissionName,
    onChange: handlePermissionNameChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: PERMISSION_PERSONAL
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(PersonalIcon, {
    className: classes.menuIcon
  }), /*#__PURE__*/React.createElement("div", null, PERMISSION_PERSONAL))), /*#__PURE__*/React.createElement(MenuItem, {
    value: PERMISSION_TEAM
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(SharedIcon, {
    className: classes.menuIcon
  }), /*#__PURE__*/React.createElement("div", null, PERMISSION_TEAM))), isAdmin && /*#__PURE__*/React.createElement(MenuItem, {
    value: PERMISSION_GLOBAL
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(GlobalIcon, {
    className: classes.menuIcon
  }), /*#__PURE__*/React.createElement("div", null, PERMISSION_GLOBAL)))), /*#__PURE__*/React.createElement(FormHelperText, null, PERMISSION_HELPER_TEXT[permissionName])), permissionName === PERMISSION_TEAM && /*#__PURE__*/React.createElement(AsyncComboBox, {
    url: url,
    textFieldProps: {
      label: "Teams",
      fullWidth: true
    },
    value: permissionTeams || [],
    onChange: function onChange(event, value) {
      return setPermissionTeams(value);
    },
    multiple: true,
    autoSelect: false
  })));
};
export default TeamsConfigurationPermission;